import { Component } from "react";
import PropTypes from "prop-types";
import map from "lodash/map";
import { LOGGED_OUT_TEXT } from "../../../shared/ui/components/WishlistToggle";
import * as api from "../../data/api";
import withUserWishlistProgrammeIds from "../../../shared/ui/containers/WithUserWishlistProgrammeIds";

class WishlistCardsContainer extends Component {
  static propTypes = {
    session: PropTypes.object.isRequired,

    // Injected by withUserWishlistProgrammeIds
    isInWishlist: PropTypes.func.isRequired,
    addToWishlist: PropTypes.func.isRequired,
    removeFromWishlist: PropTypes.func.isRequired,
    initializeWishlistProgrammeIds: PropTypes.func.isRequired,
  };

  wishlistToggles = [];

  /**
   * Lifecycle functions
   */
  componentDidMount() {
    this.initialize();
  }

  initialize() {
    this.props.initializeWishlistProgrammeIds(
      this.props.session.user ? map(this.props.session.user.programmeWishList, "id") : []
    );

    this.wishlistToggles = document.querySelectorAll(".wishlist-toggle");
    this.updateWishlistToggles();

    window.handleWishlistToggleClick = this.handleWishlistToggleClick;
    if (document && document.addEventListener) {
      document.addEventListener("click", window.handleWishlistToggleClick, false);
    }
  }

  componentWillUnmount() {
    if (document && document.removeEventListener && window.handleWishlistToggleClick) {
      document.removeEventListener("click", window.handleWishlistToggleClick);
    }
  }

  /**
   * Functions
   */
  _toggleIcon(icon, isAddedToWishlist) {
    if (isAddedToWishlist === true) {
      icon.classList.add("fas");
      icon.classList.remove("fal");
    } else {
      icon.classList.add("fal");
      icon.classList.remove("fas");
    }
  }

  updateWishlistToggles() {
    this.wishlistToggles.forEach((wishlistToggle) => {
      if (this.props.session.user === null) {
        wishlistToggle.setAttribute("title", LOGGED_OUT_TEXT);
        wishlistToggle.setAttribute("data-original-title", LOGGED_OUT_TEXT);
      } else {
        const programmeId = wishlistToggle.dataset.wishlistProgrammeId;
        const icon = wishlistToggle.children[0];

        this._toggleIcon(icon, this.props.isInWishlist(programmeId));

        wishlistToggle.classList.remove("wishlist-toggle--disabled");
        wishlistToggle.removeAttribute("data-toggle");
        wishlistToggle.removeAttribute("data-placement");
      }
    });
  }

  handleWishlistToggleClick = (e) => {
    e = e || window.event;
    const target = e.target || e.srcElement;
    const element = target.closest(".wishlist-toggle");

    if (element === null) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    if (element.classList.contains("wishlist-toggle--disabled")) {
      return;
    }

    const programmeId = element.dataset.wishlistProgrammeId;
    const icon = element.children[0];

    if (this.props.isInWishlist(programmeId)) {
      // already in wishlist (want to remove from wishlist)
      this._toggleIcon(icon, false);
      this.props.removeFromWishlist(programmeId);

      element.classList.add("wishlist-toggle--disabled");
      api.postRemoveFromWishlist(programmeId, this.props.session.appToken).then(() => {
        element.classList.remove("wishlist-toggle--disabled");
      });
    } else {
      // not in wishlist (want to add to wishlist)
      this._toggleIcon(icon, true);
      this.props.addToWishlist(programmeId);

      element.classList.add("wishlist-toggle--disabled");
      api.postAddToWishlist(programmeId, this.props.session.appToken).then(() => {
        element.classList.remove("wishlist-toggle--disabled");
      });
    }
  };

  render() {
    return null;
  }
}

export default withUserWishlistProgrammeIds()(WishlistCardsContainer);
